/**
 * Component Entry
 *
 */

import InputMasked from './InputMasked'
export default InputMasked
export * from './InputMasked'

export { default as MultiInputMask } from './MultiInputMask'
export * from './MultiInputMask'
